module.exports = __webpack_public_path__ + "static/scale-model-of-any-seasons-travel-in-odessa-texas-2ffb288434203d7bb84af72c28d59048.png";